define('models/transfer/suggestion',['backbone'], function(Backbone){
	var Suggestion = Backbone.Model.extend({
		initialize: function(options) {
			options || (options = {});
			this.avatar =  null;
		},
		parse: function (data) {

			var response = {};

			response.user_guid = data.user_guid;
			response.entity_type_id = data.entity_type_id;
			response.first_name = data.first_name;
			response.last_name = data.last_name;
			response.city = data.city;
			response.state = data.state;
			response.zip = data.zip;
			response.logo = buildImageURL(pf.enums.entityTypeCodeEnum.User, data.user_guid, pf.enums.imageTypeGUIDEnum.Thumbnail, data.logo);
					 						 
			return response;
			
		},
	});
	return Suggestion;
});
